<template>
  <InterfaceCard
      icon="mdi-store"
      title="Выберите точку выдачи"
  >
    <PickupPointSelector
        :disabled="process"
        :loading="loading"
        :pickup-points="buyout && buyout.pickupPoints"
        :selected-id="selectedPickupPointId"
        @select="setPickupPoint"
    ></PickupPointSelector>

    <Info
        v-if="error"
        :error="error"
    ></Info>

    <v-btn
      slot="actions"
      class="back"
      color="red"
      text
      @click="toBackState"
    >
      <v-icon left>mdi-chevron-left</v-icon>
      Назад
    </v-btn>
  </InterfaceCard>
</template>

<script>
import Info from '@/components/Info'
import InterfaceCard from '@/components/InterfaceCard'
import PickupPointSelector from '@/components/PickupPointSelector'
import {appStates} from '@/constants'

export default {
  name: 'BuyoutPickupPointSet',
  components: {Info, PickupPointSelector, InterfaceCard},
  created () {
    Promise.all([
      this.$client.get(this.$API.BUYOUTS.ITEM, {params: {buyoutId: this.$route.params.buyoutId}}),
      this.$client.get(this.$API.BUYOUTS.BUYOUT_ITEM, {params: {buyoutId: this.$route.params.buyoutId}})
    ]).then(([buyoutRs, buyoutItemRs]) => {
      this.buyout = buyoutRs
      // this.pickupPoints = this.buyout.pickupPoints
      this.buyoutItem = buyoutItemRs
      this.selectedPickupPointId = this.buyoutItem.pickupPointIdCustomer
    }).catch(err => this.error = err)
    .finally(() => this.loading = false)

  },
  data () {
    return {
      buyout: null,
      buyoutItem: null,
      error: null,
      loading: true,
      process: false,
      selectedPickupPointId: null
    }
  },
  methods: {
    setPickupPoint (item) {
      if (this.buyoutItem.pickupPointIdCustomer !== item.id) {
        this.process = true
        this.$client.post(this.$API.BUYOUTS.BUYOUT_ITEM_PICKUP_POINTS, {
          buyoutItemId: this.buyoutItem.id, pickupPointId: item.id
        })
        .then(() => this.toBackState())
      }
    },
    toBackState () {
      this.$route.query.invoiceId ? this._toPay() : this._toOrders()
    },
    _toPay () {
      const params = {
        sourceId: this.$route.params.sourceId,
        buyoutId: this.$route.params.buyoutId,
        invoiceId: this.$route.query.invoiceId
      }
      let stateName = appStates.buyoutPaymentConfirmation.name;
      if (this.buyoutItem.paymentUrl) {
        stateName = appStates.buyoutPayment.name
      }
      this.$router.replace({name: stateName, params})
    },
    _toOrders () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.back {
  width: 100%;
}
</style>